// extracted by mini-css-extract-plugin
module.exports = {"fireIcon":"MostTradableTokens_fireIcon__KBGyI","distort":"MostTradableTokens_distort__7xeih","hideScrollbar":"MostTradableTokens_hideScrollbar__SvB__"};